import { StateParams } from '@uirouter/core';
import * as angular from 'angular';
import { ngStorage } from 'ngstorage';
import { AccountService } from '../../../account/account.service';
import { SalesAssistantFeedbackStats } from '../../../core/index';
import { StaffRatingService } from '../../../staffRating/staffRating.service';

class StaffRatingAnalyticsComponent {
    public static $inject = ['$localStorage', 'accountService', '$scope', '$stateParams', '$filter', 'staffRatingService', '$translate'];

    public viewModel: SalesAssistantFeedbackStats = {
        AllowViewRating: false,
        AverageRating: 0,
        FeedbackCount: 0,
        LastUpdateUTC: null
    };
    public isRetailer: any;

    constructor(
        private $localStorage: ngStorage.StorageService,
        protected accountService: AccountService,
        protected $scope: ng.IScope,
        protected $stateParams: StateParams,
        protected $filter: ng.IFilterService,
        protected staffRatingService: StaffRatingService,
        protected $translate: angular.translate.ITranslateService
    ) {
        this.init();
    }

    private async getStaffRatingSummary() {
        const data = await this.staffRatingService.getStaffRatingSummary(false);
        this.viewModel = data;
    }

    private init = async () => {
        this.isRetailer = await this.CheckIsAdmin();
        this.getStaffRatingSummary();
    }

    private async switchStaffRatingDisplay() {
        await this.staffRatingService.setStaffRatingSettings({ AllowViewRating: this.viewModel.AllowViewRating });
    }

    private async CheckIsAdmin() {
        if (!this.$localStorage.retailerAuthorizationData.permission) {
            this.accountService.getProfile();
        }
        return this.$localStorage.retailerAuthorizationData.permission === 1;
    }
}

angular.module('naut').component('staffRatingAnalytics', {
    template: require('./staffRatingAnalytics.component.html'),
    controller: StaffRatingAnalyticsComponent,
    controllerAs: 'vm',
    bindings: {

    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/analytics/components/staffRating/staffRatingAnalytics.component.ts